import React, { useContext, useEffect, useRef, useState } from "react";
import CustomSpinner from "../../../../../components/CustomSpinner";
import studyviewerContext from "../../../../../context/studyviewer/StudyviewerContext";
import ThumbnailContext from "../../../../../context/studyviewer/ThumbnailContext";
import {
  downloadStudyPPT,
  downloadStudyZip,
  _base64ToArrayBuffer,
  fetchDownloadProgress,
  getCompletedFileUrl,
  startDownloadingZip,
  startDownloadingPpt,
} from "../../../../../service/StudyViewerService";
import DownloadImageModal from "./DownloadImageModal";
import toastContext from "../../../../../context/toast/ToastContext";
import { TOAST_TYPE } from "../../../../../constants/Constants";
import userContext from "../../../../../context/users/UserContext";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";

// First progress check after starting a download; later checks use getFetchInterval
const FIRST_PROGRESS_POLL_MS = 1000;

const DownloadOptions = ({
  option,
  setShowDropDown,
  index,
  setLoadingState,
  showOption,
  setHoveredParent
}) => {
  const [hovered, setHovered] = useState(false);
  const { username } = useContext(userContext);
  const [downloadImageModal, setDownloadImageModal] = useState(false);
  const {
    showToastv2,
    showProgressToast,
    setProgressList,
    progressList,
    updateProgress,
    hideProgress,
  } = useContext(toastContext);
  const handleMouseOver = () => {
    if (showOption && !isChildStudyActive) {
      setHovered(true);
    }
  };

  const handleMouseLeave = () => {
    if (showOption && !isChildStudyActive) {
      setHovered(false);
    }
  };

  const handleDownloadClick = async () => {
    if (showOption && !isChildStudyActive) {
      setHoveredParent(false);
      if (index === 0) {
        await handleStudyDownloadZip();
      } else if (index === 1) {
        await handleStudyDownlaodPPT();
      } else if (index === 2) {
        setDownloadImageModal(true);
      }
    }
    // setShowDropDown(false);
  };

  const { studyParentId, studyData, setShowToast } =
    useContext(studyviewerContext);
  const { activeThumbnailIndex } = useContext(ThumbnailContext);
  const { isChildStudyActive } = useContext(ViewportContext);

  const [studyZipProgress, setStudyZipProgress] = useState(0);
  const [studyZipProgressId, setStudyZipProgressId] = useState(0);
  const [studyPptProgress, setStudyPptProgress] = useState(0);
  const [studyPptProgressId, setStudyPptProgressId] = useState(0);
  const [zipToken, setZipToken] = useState("");
  const [zipFetchInterval, setZipFetchInterval] = useState(0);
  const [pptToken, setPptToken] = useState("");
  const [pptFetchInterval, setPptFetchInterval] = useState(0);
  // Every progress-poll interval, so leaving the viewer stops them all
  const pollIntervalsRef = useRef(new Set());
  // Tokens whose file the browser was already sent to download. Several progress polls can be
  // in flight at once (each progress change starts one, and a slow response overlaps the next
  // tick); each that saw 100 set progress back to 90 and started the same download again.
  const startedDownloadsRef = useRef(new Set());
  const trackInterval = (intervalId) => {
    pollIntervalsRef.current.add(intervalId);
    return intervalId;
  };
  useEffect(() => {
    const pollIntervals = pollIntervalsRef.current;
    return () => pollIntervals.forEach((intervalId) => clearInterval(intervalId));
  }, []);

  useEffect(() => {
    if (studyZipProgress === 0) return;
    // updateProgressList(1, studyZipProgress);

    if (studyZipProgress < 90) {
      // const updatedProgressIndex = progressList.findIndex(
      //   (p) => p.id === studyZipProgressId
      // );
      // const updatedProgress = progressList[updatedProgressIndex];
      // updatedProgress.progress = studyZipProgress;
      // const newProgressList = [...progressList];
      // newProgressList[updatedProgressIndex] = updatedProgress;
      // setProgressList(newProgressList);
      updateProgress(studyZipProgressId, studyZipProgress);
      const oldProgress = studyZipProgress;
      let progress;
      const zipProgressInterval = trackInterval(setInterval(async () => {
        progress = await fetchZipDownloaddProgress(zipProgressInterval);
        if (progress > oldProgress) {
          clearInterval(zipProgressInterval);
        }
      }, zipFetchInterval));
    }

    if (studyZipProgress === 90) {
      updateProgress(studyZipProgressId, studyZipProgress);
      downloadFile(zipToken, true);
    }

    if (studyZipProgress === 100) {
      updateProgress(studyZipProgressId, studyZipProgress);
      setTimeout(() => {
        hideProgress(studyZipProgressId);
        setStudyZipProgress(0);
      }, 3000);
    }
  }, [studyZipProgress]);

  useEffect(() => {
    if (studyPptProgress === 0) return;
    // updateProgressList(1, studyZipProgress);

    if (studyPptProgress < 90) {
      //
      updateProgress(studyPptProgressId, studyPptProgress);
      const oldProgress = studyPptProgress;
      let progress;
      const pptProgressInterval = trackInterval(setInterval(async () => {
        progress = await fetchPptDownloaddProgress(pptProgressInterval);
        if (progress > oldProgress) {
          clearInterval(pptProgressInterval);
        }
      }, pptFetchInterval));
    }

    if (studyPptProgress === 90) {
      updateProgress(studyPptProgressId, studyPptProgress);
      downloadFile(pptToken, false);
    }

    if (studyPptProgress === 100) {
      updateProgress(studyPptProgressId, studyPptProgress);
      setTimeout(() => {
        hideProgress(studyPptProgressId);
        setStudyPptProgress(0);
      }, 3000);
    }
  }, [studyPptProgress]);

  useEffect(() => {
    let progress;
    if (zipToken !== "") {
      const zipProgressInterval = trackInterval(setInterval(async () => {
        progress = await fetchZipDownloaddProgress(zipProgressInterval);
        if (progress > 0) {
          clearInterval(zipProgressInterval);
        }
        // first check soon, so a zip that is already built (reused) starts downloading at once
      }, Math.min(zipFetchInterval, FIRST_PROGRESS_POLL_MS)));
    }
  }, [zipToken]);

  useEffect(() => {
    let progress;
    if (pptToken !== "") {
      const pptProgressInterval = trackInterval(setInterval(async () => {
        progress = await fetchPptDownloaddProgress(pptProgressInterval);
        if (progress > 0) {
          clearInterval(pptProgressInterval);
        }
      }, Math.min(pptFetchInterval, FIRST_PROGRESS_POLL_MS)));
    }
  }, [pptToken]);

  const fetchZipDownloaddProgress = async (zipProgressInterval) => {
    if (startedDownloadsRef.current.has(zipToken)) {
      clearInterval(zipProgressInterval);
      return 100;
    }
    const response = await fetchDownloadProgress(zipToken);
    // Another poll for this token may have finished first and started the download already
    if (startedDownloadsRef.current.has(zipToken)) {
      clearInterval(zipProgressInterval);
      return 100;
    }
    if (response.status === 200) {
      if (response.data.data.status === "FAILED") {
        hideProgress(studyZipProgressId);
        setStudyZipProgress(0);
        showToastv2(
          TOAST_TYPE.ERROR,
          response.data.data.error
            ? response.data.data.error
            : "Failed to download file."
        );
        clearInterval(zipProgressInterval)
        return;
      }
      if (response.data.data.progress === 100) {
        setStudyZipProgress(90);
      } else {
        // 90 means "zip ready, start the download" here, so a build still running stays below it
        setStudyZipProgress(Math.min(response.data.data.progress, 89));
      }
    }
    return response.data.data.progress;
  };

  const fetchPptDownloaddProgress = async (pptProgressInterval) => {
    if (startedDownloadsRef.current.has(pptToken)) {
      clearInterval(pptProgressInterval);
      return 100;
    }
    const response = await fetchDownloadProgress(pptToken);
    if (startedDownloadsRef.current.has(pptToken)) {
      clearInterval(pptProgressInterval);
      return 100;
    }
    if (response.status === 200) {
      if (response.data.data.status === "FAILED") {
        hideProgress(studyPptProgressId);
        setStudyPptProgress(0);
        showToastv2(
          TOAST_TYPE.ERROR,
          response.data.data.error
            ? response.data.data.error
            : "Failed to download file."
        );
        clearInterval(pptProgressInterval);
        return;
      }
      if (response.data.data.progress === 100) {
        setStudyPptProgress(90);
      } else {
        setStudyPptProgress(Math.min(response.data.data.progress, 89));
      }
    }
    return response.data.data.progress;
  };

  // The browser downloads the finished file itself: it streams to disk (no copy in the tab's
  // memory, so multi-GB studies are fine), shows in the browser's download bar and can resume.
  // The server answers 204 for an expired or unknown token, which keeps this page as it is.
  const downloadFile = (token, isZip) => {
    // Once per token: overlapping progress polls can each report "ready"
    if (!token || startedDownloadsRef.current.has(token)) return;
    startedDownloadsRef.current.add(token);
    const link = document.createElement("a");
    link.href = getCompletedFileUrl(token);
    link.rel = "noopener";
    document.body.appendChild(link);
    link.click();
    link.remove();
    if (isZip) {
      showToastv2(TOAST_TYPE.SUCCESS, "Study download started. See your browser's downloads.");
      setStudyZipProgress(100);
    } else {
      showToastv2(TOAST_TYPE.SUCCESS, "PPT download started. See your browser's downloads.");
      setStudyPptProgress(100);
    }
  };

  const handleStudyDownloadZip = async () => {
    // setLoadingState(true);

    if (studyZipProgress > 0 && studyZipProgress < 100) {
      showToastv2(TOAST_TYPE.INFO, "You zip is getting download. Please wait");
      return;
    }

    const id = showProgressToast("Downloading zip", studyZipProgress);
    setStudyZipProgressId(id);
    // setStudyZipProgress(5);
    const response = await startDownloadingZip(studyParentId);
    console.log(response);
    if (response.status === 201) {
      setZipToken(response.data.data.token);
      setZipFetchInterval(getFetchInterval(response.data.data.imageCount));
      showToastv2(TOAST_TYPE.INFO, "Downloading started");
    } else {
      showToastv2(TOAST_TYPE.ERROR, "Failed to start downloading");
      hideProgress(studyZipProgressId);
    }
  };

  const handleStudyDownlaodPPT = async () => {
    if (studyPptProgress > 0 && studyPptProgress < 100) {
      showToastv2(TOAST_TYPE.INFO, "You ppt is getting download. Please wait");
      return;
    } // setLoadingState(true);

    const id = showProgressToast("Study Ppt", studyZipProgress);
    setStudyPptProgressId(id);
    // setStudyPptProgress(5);
    const response = await startDownloadingPpt(
      studyParentId,
      studyData.stacks[activeThumbnailIndex].stackId
    );
    if (response.status === 201) {
      setPptToken(response.data.data.token);
      setPptFetchInterval(getFetchInterval(response.data.data.imageCount));
      showToastv2(TOAST_TYPE.INFO, "Downloading PPT");
    } else {
      showToastv2(TOAST_TYPE.ERROR, "Failed to start downloading");
      hideProgress(studyPptProgressId);
    }
  };

  const getFetchInterval = (imageCount) => {
    if (imageCount > 0 && imageCount <= 10) return 1000;
    else if (imageCount > 10 && imageCount <= 100) return 2000;
    else if (imageCount > 100 && imageCount <= 300) return 3000;
    else if (imageCount > 300 && imageCount <= 500) return 4000;
    else return 5000;
  };

  // showOption already gated every handler below, but the row still rendered at
  // full opacity with a pointer cursor - so an option that could not act (e.g.
  // "Download images" while a document viewport is active, which has no rendered
  // image to capture) looked live and silently did nothing on click.
  const isDisabled = !showOption || isChildStudyActive;

  return (
    <>
      {/* {loadingState && <CustomSpinner />} */}
      <div
        className={`viewer-download-button${isDisabled ? " disabled" : ""}`}
        style={{
          display: "flex",
          alignItems: "center",
          height: "40px",
          // color: `${hovered ? "#0085FF" : "white"}`,
          cursor: `${!isDisabled ? "pointer" : "not-allowed"}`,
        }}
        onMouseOver={handleMouseOver}
        onMouseLeave={handleMouseLeave}
        onClick={handleDownloadClick}
      >
        {option}
      </div>
      {downloadImageModal && (
        <DownloadImageModal
          downloadImageModal={downloadImageModal}
          setDownloadImageModal={setDownloadImageModal}
        />
      )}
    </>
  );
};

export default DownloadOptions;
